import { FC } from 'react';
import clsx from 'clsx';

import * as style from './style.css';
import { UIHeading4 } from '@cian/ui-kit';

interface IButtonProps {
  title: string;
  url: string;
  className: string;
  onClick: (buttonName: string) => void;
}

export const Button: FC<IButtonProps> = ({ title, url, className, onClick }) => {
  return (
    <a className={style['content']} href={url} onClick={() => onClick('download_app')}>
      <div className={clsx(style['icon'], style[className])}></div>
      <div className={style['text']}>
        <UIHeading4 color="white_100">{title}</UIHeading4>
      </div>
    </a>
  );
};
